module.exports = __webpack_public_path__ + "static/media/nogal_otranto.c73779e3.jpg";